export default __webpack_public_path__ + "static/backstage-quest-156e96ece98e5acb8881b93beeddb52c.png";